@if(formControlItem){
<label class="block text-sm text-black tracking-tight">

    <span class="font-bold">
        {{label}}

        @if(isRequired){
        @let isInvalid = formControlItem.invalid && (formControlItem.touched || formControlItem.dirty);

        <span [class.text-gray-400]="!isInvalid" [class.text-red-500]="isInvalid">*</span>
        }
    </span>

    @if(decimal){
    <!-- Decimal mode: text input accepting both "." and "," (see DecimalInputDirective). -->
    <input #internalInput type="text" inputmode="decimal" decimalInput [padDecimals]="padDecimals"
        [placeholder]="placeholder" [formControl]="formControlItem" (keydown.tab)="doTab()"
        class="w-full px-3 py-1 text-xs rounded-xl placeholder-neutral-400 focus:outline-none transition-all duration-100 ease-in"
        [class]="inputClass || 'text-slate-700 bg-slate-50 border border-slate-200 focus:ring-1 focus:ring-black focus:shadow-lg focus:shadow-black/5 hover:bg-neutral-50'">
    } @else if(type === 'password'){
    <div class="relative">
        <input #internalInput type="password" [placeholder]="placeholder" [formControl]="formControlItem"
            (keydown.tab)="doTab()"
            class="w-full pl-3 pr-9 py-1 text-xs rounded-xl placeholder-neutral-400 focus:outline-none transition-all duration-100 ease-in"
            [class]="inputClass || 'text-slate-700 bg-slate-50 border border-slate-200 focus:ring-1 focus:ring-black focus:shadow-lg focus:shadow-black/5 hover:bg-neutral-50'">
        <password-toggle [input]="internalInput" />
    </div>
    } @else {
    <input #internalInput [type]="type" [placeholder]="placeholder" [formControl]="formControlItem"
        (keydown.tab)="doTab()"
        class="w-full px-3 py-1 text-xs rounded-xl placeholder-neutral-400 focus:outline-none transition-all duration-100 ease-in"
        [class]="inputClass || 'text-slate-700 bg-slate-50 border border-slate-200 focus:ring-1 focus:ring-black focus:shadow-lg focus:shadow-black/5 hover:bg-neutral-50'">
    }
    @if(formControlItem.invalid && (formControlItem.touched || formControlItem.dirty)){
    <div class="text-red-600 text-xs mt-1">{{ errorMessage }}</div>
    }
</label>
}